import { storage, StorageKey } from '@/lib/storage';

/**
 * La vibrazione: dove si ricorda.
 *
 * ⚠️ Fino a questo giro `settings.hapticsEnabled` viveva SOLO in Redux (`settings.slice.ts`, a differenza di
 * `appearance.slice`, che si idrata da `localStorage`): chi la spegneva in «Preferenze» la ritrovava accesa a
 * ogni avvio dell'app. Una preferenza che si dimentica non e' una preferenza.
 *
 * Il default e' ACCESO, com'era: solo un `'0'` esplicito lo spegne. Un valore che non conosciamo, o un
 * `localStorage` che lancia (`storage.get` ripiega su `null`), vale il default: un telefono che non ricorda non
 * deve restare muto per una chiave illeggibile.
 */
export function leggiHapticsEnabled(): boolean {
  return storage.get(StorageKey.HapticsEnabled) !== '0';
}

export function scriviHapticsEnabled(acceso: boolean): void {
  storage.set(StorageKey.HapticsEnabled, acceso ? '1' : '0');
}
